<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fs-4 fw-semibold">
    <i class="bi bi-person-add me-2 text-success"></i> Client
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<ng-container *ngIf="loading_get_details_add_utilisateur_form; else form_add_utilisateur">
  <div class="modal-body px-4 gap-2 mt-3">
    <div class="d-flex justify-content-center align-items-center" style="height: 200px;">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #form_add_utilisateur>
  <div class="modal-body px-4 gap-2 mt-3">
    <form [formGroup]="reactiveForm_add_utilisateur" (ngSubmit)="onSubmit_add_utilisateur()">
      <div class="mb-4">
        <h6 class="fw-bold fs-5 mb-3">
          <i class="bi bi-person me-2 text-primary"></i> Informations personnelles
        </h6>
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label fs-6">Nom complet <span class="text-danger">*</span></label>
            <input type="text" class="form-control " formControlName="nom" placeholder=""
              [ngClass]="{ 'is-invalid': submitted && f.nom.errors }" />
            @if (submitted && f.nom.errors) {
            <div class="invalid-feedback">
              @if (f.nom.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div>
        </div>

        <div class="row g-3 mt-3">
          <div class="col-md-6">
            <label class="form-label fs-6">Année de naissance <span class="text-danger">*</span></label>
            <ng-select formControlName="annee_naissance"
              [ngClass]="{ 'is-invalid': submitted && f.annee_naissance.errors }"
              placeholder="Sélectionner l'année de naissance">

              <ng-option *ngFor="let an of anneesNaissance" [value]="an">
                {{ an }}
              </ng-option>
            </ng-select>

            @if (submitted && f.annee_naissance.errors) {
            <div class="invalid-feedback">
              @if (f.annee_naissance.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }


          </div>
          <div class="col-md-6">
            <label class="form-label fs-6">Genre</label>
            <ng-select formControlName="id_genre" [ngClass]="{ 'is-invalid': submitted && f.id_genre.errors }">
              <ng-option value="" disabled>Choisir le genre</ng-option>
              <ng-option *ngFor="let genre of form_details.les_genres" [value]="genre.id_genre">
                {{ genre.nom_genre }}
              </ng-option>
            </ng-select>
            @if (submitted && f.id_genre.errors) {
            <div class="invalid-feedback">
              @if (f.id_genre.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div>
        </div>

        <div class="row g-3 mt-3">
          <div class="col-md-12">
            <label class="form-label fs-6">Téléphone <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="telephone" placeholder=""
              [ngClass]="{ 'is-invalid': submitted && f.telephone.errors }" />
            @if (submitted && f.telephone.errors) {
            <div class="invalid-feedback">
              @if (f.telephone.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div>
          <!-- <div class="col-md-6">
            <label class="form-label fs-6">Email</label>
            <input type="email" class="form-control " formControlName="email" placeholder="Saisir l'email"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            @if (submitted && f.email.errors) {
            <div class="invalid-feedback">
              @if (f.email.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div> -->
        </div>

        <div class="mt-3">
          <label class="form-label fs-6">Adresse</label>
          <input type="text" class="form-control " formControlName="adresse" placeholder="Saisir l'adresse"
            [ngClass]="{ 'is-invalid': submitted && f.adresse.errors }" />
          @if (submitted && f.adresse.errors) {
          <div class="invalid-feedback">
            @if (f.adresse.errors.required) {
            <div>Ce champ est obligatoire</div>
            }
          </div>
          }
        </div>
      </div>
      <div class="mb-4">
        <h6 class="fw-bold fs-5 mb-3">
          <i class="bi bi-shield-lock me-2 text-primary"></i> Informations de connexion
        </h6>
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label fs-6">Mot de passe <span class="text-danger">*</span></label>
            <div class="input-group">
              <input [type]="showpassword ? 'text' : 'password'" class="form-control form-control-sm"
                formControlName="password" placeholder="créer un mot de passe"
                [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
              <button type="button" class="btn btn-outline-secondary" (click)="shoow_hide_password()">
                <i class="bi" [ngClass]="showpassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            @if (submitted && f.password.errors) {
            <div class="invalid-feedback">
              @if (f.password.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div>

        </div>
      </div>

      <div class="mb-4">
        <h6 class="fw-bold fs-5 mb-3">
          <i class="bi bi-info-circle me-2 text-primary"></i> Informations supplémentaires
        </h6>
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label fs-6">Expérience de conduite <span class="text-danger">*</span></label>
            <ng-select formControlName="annee_debut_conduite"
              [ngClass]="{ 'is-invalid': submitted && f.annee_debut_conduite.errors }">
              <ng-option value="" disabled>Sélectionner l'expérience</ng-option>
              <ng-option *ngFor="let option of experienceOptions" [value]="option.value">
                {{ option.label }}
              </ng-option>
            </ng-select>
            @if (submitted && f.annee_debut_conduite.errors) {
            <div class="invalid-feedback">
              @if (f.annee_debut_conduite.errors.required) {
              <div>Ce champ est obligatoire</div>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 pt-0">
    <button type="submit" class="btn btn-success" (click)="onSubmit_add_utilisateur()"
      [disabled]="loading_add_utilisateur">
      <i class="bi bi-check-lg me-2"></i> Enregistrer
      <span *ngIf="loading_add_utilisateur" class="spinner-border spinner-border-sm ms-2" role="status"
        aria-hidden="true"></span>
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.close()"
      [disabled]="loading_add_utilisateur">
      <i class="bi bi-x-lg me-2"></i> Annuler
    </button>
  </div>
</ng-template>
